<template>
  <div :class="$style.career">
    <h2 id="js-career-system-title" :class="$style.title">
      <span class="app-fadeInUp">职业发展体系</span>
    </h2>
    <div id="js-career-system-content" :class="$style.content">
      <div class="app-fadeInUp" :class="$style.brief">
        <p>能力为第一考评标准，</p>
        <p>无关年龄，经验，</p>
        <p>相信你总能在极致找到自己的目标！</p>
      </div>
      <the-career-system-tooltip
        v-for="(el, index) in level"
        :key="index"
        :data="el"
        :class="[$style.level, $style[`level_${index + 1}`]]"
      />
    </div>
  </div>
</template>

<script>
import fadeMixins from '@/assets/js/fadeMixins'
import TheCareerSystemTooltip from './TheCareerSystemTooltip'

export default {
  components: { TheCareerSystemTooltip },
  mixins: [fadeMixins],
  data() {
    return {
      name: 'career-system',
      animateScenesData: ['title', 'content'],
      level: [
        {
          name: 'P1',
          title: '初学者',
          color: 'green',
          tip: '具备一定的业务知识基础，在他人指导下完成工作',
        },
        {
          name: 'P2',
          title: '有经验者',
          color: 'green',
          tip: '业务熟练，具备高度执行力，能够在某一模块独立开展工作',
        },
        {
          name: 'P3',
          title: '业务中坚',
          color: 'green',
          tip: '业务较为突出，具备一定的工作组织能力',
        },
        {
          name: 'P4',
          title: '核心骨干',
          color: 'orange',
          tip:
            '专业深入、扎实、全面，能灵活高效的开展工作，具备一定的业务前瞻性和业务影响力',
        },
        {
          name: 'P5',
          title: '领域专家',
          color: 'orange',
          tip:
            '专业功底扎实 、知识面广，所专长的部分在内部具有权威性，能主导、全面统筹、部署执行工作',
        },
        {
          name: 'P6',
          title: '公司权威',
          color: 'orange',
          tip:
            '高度的复合能力及前瞻性，能在公司级战略层面提供决策意见，业务的专业标杆',
        },
        {
          name: 'M1',
          title: '基层管理者',
          color: 'blue',
          tip:
            '具备团队梯队建设能力，较强的团队责任感，可以完成基础的团队管理工作，能有意识和方法指导下属践行企业文化',
        },
        {
          name: 'M2',
          title: '中层管理者',
          color: 'blue',
          tip:
            '部门业务及管理体系化，具备管理者培养能力，有一定的胸怀格局，是企业文化的布道者',
        },
        {
          name: 'M3',
          title: '高层管理者',
          color: 'blue',
          tip:
            '有较强的战略思维及能力，具备优秀的管理者培养能力，是企业文化的布道者',
        },
      ],
    }
  },
}
</script>

<style lang="less" module>
@career-width: 19.2rem;
@career-height: 10.51rem;
@career-title-top: 1.33rem;

.level-size(@top: 1) {
  &_1 {
    top: 9.92rem * @top;
  }

  &_2 {
    top: 8.62rem * @top;
  }

  &_3 {
    top: 7.83rem * @top;
  }

  &_4 {
    top: 7.38rem * @top;
  }

  &_5 {
    top: 5.27rem * @top;
  }

  &_6 {
    top: 3.06rem * @top;
  }

  &_7 {
    top: 7.38rem * @top;
  }

  &_8 {
    top: 5.27rem * @top;
  }

  &_9 {
    top: 3.06rem * @top;
  }
}

.career {
  position: relative;
  height: @career-height;
  padding-top: @career-title-top;
  background: url('./images/career-system-bg.jpg') no-repeat;
  background-size: @career-width @career-height;
  box-sizing: border-box;
}

.title {
  span {
    .subtitle-size(4.69rem, 0.61rem);
    .text-hide();
    display: block;
    margin: 0 auto;
    background: url('./images/career-system-title.png') no-repeat;
    background-size: 100% 100%;
  }
}

.content {
  margin-top: 0.63rem;
}

.brief {
  text-align: center;

  p {
    margin-top: 1.5em;
    color: #858585;
  }

  // 分隔线
  &::before {
    .size(0.5rem, 1px);
    content: '';
    display: block;
    margin: 0 auto;
    background-color: @primary;
  }
}

.level {
  .level-size();
  position: absolute;

  &_1 {
    z-index: 6;
    left: 11.53rem;
  }

  &_2 {
    z-index: 5;
    left: 10.11rem;
  }

  &_3 {
    z-index: 4;
    left: 9.1rem;
  }

  &_4 {
    z-index: 3;
    left: 7.39rem;
  }

  &_5 {
    z-index: 2;
    left: 6.45rem;
  }

  &_6 {
    z-index: 1;
    left: 4.4rem;
  }

  &_7 {
    z-index: 3;
    left: 11.44rem;
  }

  &_8 {
    z-index: 2;
    left: 12.38rem;
  }

  &_9 {
    z-index: 1;
    left: 14.42rem;
  }
}

@media screen and (max-width: @tablet-width) {
  .content {
    margin-top: 1em;
  }

  .brief {
    p {
      margin-top: 0.5em;
    }
  }
}

@media screen and (max-width: @mini-width) {
  .career {
    height: @career-height * @develop-mini;
    padding-top: @career-title-top * @develop-mini;
    background-position: center bottom;
    background-size: @career-width * @develop-mini @career-height *
      @develop-mini;
  }

  .brief {
    display: none;
  }

  .level {
    .level-size(@develop-mini);

    &_1 {
      left: 12.3rem;
    }

    &_2 {
      left: 10.4rem;
    }

    &_3 {
      left: 8.85rem;
    }

    &_4 {
      left: 6.5rem;
    }

    &_5 {
      left: 4.85rem;
    }

    &_6 {
      left: 1.8rem;
    }

    &_7 {
      left: 12.1rem;
    }

    &_8 {
      left: 13.75rem;
    }

    &_9 {
      left: 16.8rem;
    }
  }
}
</style>
